// =============================================
// KvCategoriesTab (Masters) — category management for the vault
// =============================================
import React, { useState } from 'react';
import { CategoryRow, LinkRow, NotesBundle } from './notesLib';
import CategoryTree from './CategoryTree';

interface Props {
  categories: CategoryRow[];
  links: LinkRow[];
  onReload: () => Promise<NotesBundle>;
  onOpenCategory?: (categoryId: number) => void; // jump to Notes filtered by this category
}

const KvCategoriesTab: React.FC<Props> = ({ categories, links, onReload, onOpenCategory }) => {
  const [msg, setMsg] = useState<string | null>(null);
  return (
    <div className="kvc-tab">
      <div className="kvc-head">
        <div>
          <h3>Categories</h3>
          <p className="kvc-sub">Organize your knowledge into main → sub → sub-sub categories. An entry can live in several. Click a category to see its entries.</p>
        </div>
      </div>
      {msg && <div className="kvc-msg">{msg}</div>}
      <CategoryTree categories={categories} links={links} onReload={onReload} onOpenCategory={onOpenCategory} onMsg={setMsg} />
    </div>
  );
};

export default KvCategoriesTab;
